<template>
    <div style="padding-bottom: 6rem">
        <header>
            <h1>SANTANDER EMISSÕES</h1>
        </header>
        <section class="santander-emissao">
            <div class="container">
                <div class="row">
                    <form id="formSantanderEmissao">
                        <fieldset class="fieldset-border">
                            <legend class="legend-border">Chave de pesquisa</legend>
                            <div class="row">
                                <div class="col-5 col-sm-5 col-md-5, form-fields">
                                    <select v-model="tipoChave" class="form-select" required>
                                        <option disabled value="">Selecione uma opção</option>
                                        <option value="apolice" selected>Apólice</option>
                                        <option value="endosso">Endosso</option>
                                        <option value="negocio">Negócio</option>
                                        <option value="vc">VC</option>
                                    </select>
                                </div>
                                <div class="col-5 col-sm-5 col-md-5, form-fields">
                                    <div class="form-outline">
                                        <input v-model="chave" class="form-control" maxlength="38" required
                                            type="text" />
                                        <label class="form-label" for="">Chave</label>
                                        <FormNotch />
                                    </div>
                                </div>
                                <div class="col-2 col-sm-2 col-md-2 justify-content-center, form-fields">
                                    <button @click="getSantanderEmissao(tipoChave, chave);"
                                        class="search">Pesquisar</button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
            <div v-if="verTabelas">
                <div class="aba">
                    <button @click="selecionarAba('aba-arquivo-emissao')" class="button-emissao"
                        :class="{ active: abaAtual === 'aba-arquivo-emissao' }">Arquivo de Emissões</button>
                    <button @click="selecionarAba('aba-atualizacoes-vc')" class="button-vc"
                        :class="{ active: abaAtual === 'aba-atualizacoes-vc' }">Atualizações de VCs</button>
                </div>
                <div class="row">
                    <div class="col">
                        <table v-show="abaAtual === 'aba-arquivo-emissao'" class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Ramo</th>
                                    <th>Apólice</th>
                                    <th>Endosso</th>
                                    <th>VC Enviado</th>
                                    <th>Situação</th>
                                    <th>Data e Hora</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody class="form-fields">
                                <tr v-for="(item, index) in historicoFormatado" :key="index">
                                    <td>{{ item.ramoPrincipal }}</td>
                                    <td>{{ item.numApol }}</td>
                                    <td>{{ item.numEndos }}</td>
                                    <td>{{ item.cdIdetcPpotaStderVC }}</td>
                                    <td>{{ item.situacaoFinal }}</td>
                                    <td>{{ new Date(item.dataGerado).toLocaleString('pt-BR') }}</td>
                                    <td>
                                        <button class="search" @click="downloadArquivoSantander(item.idDocStore)"
                                            :disabled="item.situacaoFinal != 'PROCESSADO'">Download</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table v-show="abaAtual === 'aba-atualizacoes-vc'" class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Data e Hora</th>
                                    <th>Ramo</th>
                                    <th>Apólice</th>
                                    <th>Endosso</th>
                                    <th>VC Antigo</th>
                                    <th>VC Atualizado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in emissoes.flatMap(e => e.listaAtualizacaoVCSantander)"
                                    :key="index">
                                    <td>{{ new Date(item.dataAtualizacao).toLocaleString('pt-BR') }}</td>
                                    <td>{{ item.ramoPrincipal }}</td>
                                    <td>{{ item.numApol }}</td>
                                    <td>{{ item.numEndos }}</td>
                                    <td>{{ item.cdIdetcPpotaStderVCAntigo }}</td>
                                    <td>{{ item.cdIdetcPpotaStderVCAtualizado }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <div class="loader">
            <div>
                <div class="spinner-border"></div>
            </div>
        </div>
    </div>
</template>

<script>

import FormNotch from './FormNotch.vue';
import * as alertUtils from '@/utils/alert';
import * as ajaxUtils from '@/utils/ajax';

const baseUrl = '/massificados/corporativo/gerenciador-parceiros/rest/santander-batch';

export default {
    data() {
        return {
            abaAtual: 'aba-arquivo-emissao',
            tipoChave: '',
            chave: '',
            verTabelas: false,
            emissoes: [],
            downloadArquivo: ''
        }
    },
    computed: {
        historicoFormatado() {
            if (!Array.isArray(this.emissoes)) return [];

            return this.emissoes.flatMap(emissao => {
                if (!emissao || !Array.isArray(emissao.historico)) return [];
                return emissao.historico.map(item => ({
                    ...item,
                    // dataGeradoFinal: emissao.situacao != 'PROCESSADO' ? new Date(emissao.dataReferencia).toLocaleString('pt-BR') : item.dataGerado,
                    situacaoFinal: item.numEndos === emissao.vc.numEndos ? emissao.situacao : 'PROCESSADO'
                }));
            });
        }
    },
    mounted() {
        this.getSantanderEmissao(this.tipoChave, this.chave);
    },
    components: {
        FormNotch
    },
    methods: {
        selecionarAba(aba) {
            this.abaAtual = aba;
        },
        mostrarTabelas() {
            const temChave = this.chave && this.chave.trim() !== '';
            const temDados = Array.isArray(this.emissoes) && this.emissoes.length > 0;

            if (temChave && temDados) {
                this.verTabelas = true;
            } else {
                this.verTabelas = false;
            }
        }
        ,
        async buscarEmissao(endpoint, mensagemErro, validar = (data) => !!data) {
            try {

                const dados = await ajaxUtils.get(baseUrl + endpoint, true);
                if (!validar(dados)) {
                    alertUtils.alertError(mensagemErro);
                    return null;
                }

                return dados;
            } catch (error) {
                console.error("Erro na requisição:", error);
                alertUtils.alertError("Erro de rede ou servidor. Tente novamente.");
                return null;
            }
        },
        async getSantanderEmissao(tipoChave, chave) {
            if (!tipoChave.trim() || !chave.trim()) return;

            const endpoints = {
                apolice: `/consultar-apolice-historico/${chave}`,
                endosso: `/consultar-endosso-historico/${chave}`,
                negocio: `/consultar-negocio-historico/${chave}`,
                vc: `/consultar-vc-historico/${chave}`
            };

            const mensagensErro = {
                apolice: "Apólice não encontrada ou sem dados.",
                endosso: "Endosso não encontrado ou sem dados.",
                negocio: "Negócio não encontrado ou sem dados.",
                vc: "VC não encontrado ou sem dados."
            };

            const endpoint = endpoints[tipoChave];
            const mensagemErro = mensagensErro[tipoChave];

            if (!endpoint) return;

            const validacoes = {
                apolice: data => data && data.vc,
                endosso: data => data && data.vc,
                negocio: data => data && data.vc,
                vc: data => data && data.vc
            };

            const dados = await this.buscarEmissao(endpoint, mensagemErro, validacoes[tipoChave]);

            if (dados) {
                this.emissoes = [dados];
                this.mostrarTabelas();
            } else {
                this.emissoes = [];
                this.verTabelas = false;
            }
        },
        async downloadArquivoSantander(idDocStore) {
            try {
                const conteudo = await ajaxUtils.get(`${baseUrl}/download-arquivo-santander-emissao/${idDocStore}`);
                if (!conteudo) return;
                const blob = new Blob([conteudo], { type: 'text/plain;charset=utf-8' });
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = `${idDocStore}.txt`;
                link.click();

                URL.revokeObjectURL(url);
            } catch (erro) {
                alertUtils.alertError('Erro ao fazer download do arquivo!');
            }
        }
    }
}



</script>

<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/santander-emissao/css/style.css';
</style>
